import type { ReactNode } from 'react';

export const symbol_nature: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-140v-180h-90q-83 0-141.5-58.5T160-520q0-60 33-110.5t89-73.5q9-75 65.5-125.5T480-880q76 0 132.5 50.5T678-704q56 23 89 73.5T800-520q0 83-58.5 141.5T600-320h-90v180h200q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q722.75-80 710-80H260q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h190Zm-90-240h240q58.33 0 99.17-40.83Q740-461.67 740-520q0-42-24-76.5T654-648l-32-14-4-35q-7-53-46-88t-92-35q-53 0-92 35t-46 88l-4 35-32 14q-38 17-62 51.73-24 34.72-24 76.39Q220-462 260.83-421q40.84 41 99.17 41Zm120-220Z"
		/>
	</svg>
);
